import React from 'react';
import { connect } from 'react-redux';
import { MagnifyingGlassIcon } from "@heroicons/react/20/solid";
import cleanDeep from 'clean-deep';
import pDebounce from 'p-debounce';
import AsyncSelect from "react-select/async";
import { getAddressFromPostCode } from './validation/GetAddress';

const AddressLookUp = ({
    jurisdiction,
    disabled,
    updateInput
}) => {
    const addressOptionsPromise = pDebounce((inputValue) =>
        new Promise(async (resolve) => {
            const addressResult = (await getAddressFromPostCode({ postCode: inputValue, jurisdiction }))?.map(item => ({ ...item, label: item.fullAddress, fullAddress: undefined, value: item.fullAddress }))
            await new Promise(resolve => {
                setTimeout(() => resolve(), 1000)
            })
            resolve(addressResult)
        }), 300);

    return (
        <div className="form-material form-container">
            <AsyncSelect
                isDisabled={disabled}
                isClearable
                classNamePrefix="react-select-search"
                onChange={(selectedOption) => {
                    updateInput(cleanDeep({ ...selectedOption, label: undefined, value: undefined }))
                }}
                placeholder={<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>Enter Postcode</div>
                    <MagnifyingGlassIcon style={{ height: '2rem', display: 'block', paddingRight: '2rem' }} />
                </div>
                }
                loadOptions={addressOptionsPromise}
            />
        </div>

    );
};

const mapStateToProps = (state, ownProps) => {
    return {
        jurisdiction: state?.company?.settings?.jurisdiction,
    };
};

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(AddressLookUp);
